export const GoogleMapApiConfig = 'AIzaSyDlzw82YnTejnQVLDFbAs2DWZ7X9_9r7x8';